<template>
    <div
        class="md nav-toggle"
        :class="[showNav? 'is-active': '']"
    >
        <a @click.prevent="navToggle" :title="$t('site.func.menu')"></a>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'showNav',
            ]),
        },
        methods: {
            ...mapMutations([
                'navToggle',
            ]),
        }
    }
</script>

<style scoped lang="scss">

    .md.nav-toggle {
        position: fixed;
        left: $interval-m;
        top: 66px;
        line-height: 1;
        z-index: 7;
        margin-top: 0 !important;

        @include media('mobile') {
            display: none;
        }

        &.is-active {

            a {

                &::before { //\e5d2 => =,\e5c4 => <, \e5cd =>x
                    content: '\e9bd';
                }
            }
        }

        a {
            transition: $transition;
            display: block;
            cursor: pointer;
            border-radius: $border-radius;
            background-color: rgba-set($minor-color, $opacity-h);

            &:hover {
                background-color: $forth-color;

                &::before {
                    color: $white;
                }
            }

            &::before { //\e5d2 => =,\e5c4 => <, \e5cd =>x
                content: '\e5d2';
                @extend %font-pseudo;
                line-height: $btnInput_h;
                font-size: $font-size-xxl;
                vertical-align: bottom;
                color: $forth-color;
                width: $btnInput_h;
                text-align: center;
                transition: $transition;
            }
        }
    }
</style>
